import { create } from 'zustand';

interface State {
  selectedVehicle: string;
  setSelectedVehicle: (value: string) => void;
}

export const useVehicleStore = create<State>((set) => ({
  selectedVehicle: '',
  setSelectedVehicle: (value) => set(() => ({ selectedVehicle: value })),
}));
